import { Injectable } from '@angular/core';

declare let google: any;

@Injectable({ providedIn: 'root' })
export class GoogleServiceHub {
  placesService: any;
  autocompleteService: any;

  constructor() {
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    this.autocompleteService = new google.maps.places.AutocompleteService();
  }
}
